// src/utils/pinyinUtil.js  (paste ganti file lama)
const CDN_ESM = 'https://cdn.jsdelivr.net/npm/pinyin-pro@3.27.0/dist/index.mjs';
const CDN_UMD = 'https://cdn.jsdelivr.net/npm/pinyin-pro@3.27.0/dist/index.js';

let _lib = null;

async function ensureLib() {
  if (_lib) {
    //console.debug('[pinyinUtil] lib cached');
    return _lib;
  }

  if (typeof window !== 'undefined') {
    if (window.pinyinPro) {
      //console.debug('[pinyinUtil] found window.pinyinPro');
      _lib = window.pinyinPro;
      return _lib;
    }
    if (window.pinyinProDefault) {
      //console.debug('[pinyinUtil] found window.pinyinProDefault');
      _lib = window.pinyinProDefault;
      return _lib;
    }
  }

  try {
    console.debug('[pinyinUtil] trying dynamic ESM import:', CDN_ESM);
    const mod = await import(/* @vite-ignore */ CDN_ESM);
    _lib = mod && (mod.default ? mod.default : mod);
    if (_lib) {
      console.debug('[pinyinUtil] loaded ESM module from CDN');
      return _lib;
    }
  } catch (err) {
    console.debug('[pinyinUtil] dynamic import failed:', err && err.message);
  }

  if (typeof document !== 'undefined') {
    return new Promise((resolve) => {
      const existing = Array.from(document.getElementsByTagName('script')).find(s =>
        s.src && (s.src.includes('pinyin-pro') || s.src.includes('pinyin-pro.umd'))
      );
      if (existing) {
        console.debug('[pinyinUtil] found existing script tag, waiting load:', existing.src);
        existing.addEventListener('load', () => {
          _lib = window.pinyinPro || window.pinyinProDefault || null;
          console.debug('[pinyinUtil] existing script loaded, lib=', !!_lib);
          resolve(_lib);
        });
        existing.addEventListener('error', (e) => {
          console.debug('[pinyinUtil] existing script error', e);
          resolve(null);
        });
        return;
      }

      console.debug('[pinyinUtil] injecting UMD script:', CDN_UMD);
      const s = document.createElement('script');
      s.src = CDN_UMD;
      s.async = true;
      s.onload = () => {
        _lib = window.pinyinPro || window.pinyinProDefault || null;
        console.debug('[pinyinUtil] injected script loaded, lib=', !!_lib);
        resolve(_lib);
      };
      s.onerror = (e) => {
        console.debug('[pinyinUtil] script injection failed', e);
        resolve(null);
      };
      document.head.appendChild(s);
    });
  }

  return null;
}

export async function toPinyin(text, options = { toneType: 'none' }) {
  if (!text) return '';
  const lib = await ensureLib();
  if (!lib) {
    console.debug('[pinyinUtil] toPinyin: lib not available, fallback to original text');
    return '';
  }
  const fn = lib.pinyin || (lib.default && lib.default.pinyin) || null;
  if (!fn) {
    console.debug('[pinyinUtil] toPinyin: pinyin fn not found on lib', lib);
    return '';
  }
  try {
    const out = fn(text, options);
    console.debug('[pinyinUtil] toPinyin result:', text, '->', out);
    return out;
  } catch (e) {
    console.debug('[pinyinUtil] toPinyin call error', e && e.message);
    return '';
  }
}

export function toPinyinSync(text, options = { toneType: 'none' }) {
  if (!text) return '';
  if (!_lib) {
    if (typeof window !== 'undefined' && window.pinyinPro) {
      _lib = window.pinyinPro;
      //console.debug('[pinyinUtil] toPinyinSync attached lib from window.pinyinPro');
    } else if (typeof window !== 'undefined' && window.pinyinProDefault) {
      _lib = window.pinyinProDefault;
      //console.debug('[pinyinUtil] toPinyinSync attached lib from window.pinyinProDefault');
    } else {
      //console.debug('[pinyinUtil] toPinyinSync: lib not loaded yet, fallback to original text');
      return '';
    }
  }
  const fn = _lib.pinyin || (_lib.default && _lib.default.pinyin) || null;
  if (!fn) {
    console.debug('[pinyinUtil] toPinyinSync: pinyin fn missing on lib', _lib);
    return '';
  }
  try {
    const out = fn(text, options);
    //console.debug('[pinyinUtil] toPinyinSync result:', text, '->', out);
    return out;
  } catch (e) {
    console.debug('[pinyinUtil] toPinyinSync error', e && e.message);
    return '';
  }
}

export async function preloadPinyin() {
  const lib = await ensureLib();
  //console.debug('[pinyinUtil] preloadPinyin ->', !!lib);
  return !!lib;
}

export function capitalizePinyin(pinyinStr) {
  if (!pinyinStr) return '';
  return pinyinStr
    .split(/\s+/)
    .map(w => w ? w[0].toUpperCase() + w.slice(1) : '')
    .join(' ');
}
